import AddChangeRequestForm from './add-change-request'
import AddHardwareForm from './add-hardware'
import AddLicenseForm from './add-license'
import AddOtherCostForm from './add-other-cost'
import AddResourceForm from './add-resource'
import AddVendorForm from './add-vendor'
import AutoAddResourcesForm from './auto-add-resources'
import AutoFillManDaysForm from './auto-fill-man-days'
import ChangeProjectStatusForm from '../form/change-project-status'
import ProjectForm from './new-project'
import ProjectSubmitRequestDetail from './project-submit-request-detail'
import SubmitProjectForm from './submit-project'
import AddAttachmentForm from './upload-file'
import { ConfirmChangeStatusForm } from './confirm-change-status'
import { ConfirmSaveForm } from './confirm-save'
import { ShowRemark } from './show-remark-snapshot'

export {
  AddChangeRequestForm,
  AddHardwareForm,
  AddLicenseForm,
  AddOtherCostForm,
  AddResourceForm,
  AddVendorForm,
  AutoAddResourcesForm,
  AutoFillManDaysForm,
  ChangeProjectStatusForm,
  ProjectForm,
  ProjectSubmitRequestDetail,
  SubmitProjectForm,
  AddAttachmentForm,
  ConfirmChangeStatusForm,
  ConfirmSaveForm,
  ShowRemark,
}



// WEBPACK FOOTER //
// ./src/components/project-information/form/index.js